




























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { getDotDate } from '@core/utils/index'

@Component
export default class CouponBigItem extends Vue {
  @Prop({ default: {} }) readonly item!: any

  get couponUseTime() {
    if (this.item.useStartTime && this.item.useEndTime) {
      return getDotDate(this.item.useStartTime) + '-' + getDotDate(this.item.useEndTime)
    } else {
      return this.item.couponUseTimeDesc
    }
  }

  @Emit()
  receiveCoupon() {
    return this.item
  }
}
